import ExampleSaveButton from '../example-buttons/ExampleSaveButton.vue';
import ExampleCloseButton from '../example-buttons/ExampleCloseButton.vue';
import ExampleDeleteButton from '../example-buttons/ExampleDeleteButton.vue';

# Adding/Editing a Tag

Once you're done creating or editing your Tag, click <ExampleSaveButton /> to save the changes, or click <ExampleCloseButton /> (top right) to cancel.

## Name

This is the descriptive name for a Tag.

## Color

You can select from a variety of colors to help distinguish your tag from others.

## Deleting Tags

{/* Editor note */}
Note: There is no confirmation box, once you click <ExampleDeleteButton icon='' color='primary' /> the Tag will be removed.

To delete a Tag, Click <ExampleDeleteButton icon='' color='primary' /> (bottom left).

You can only delete User Created Tags (<v-icon>mdi-tag</v-icon>).
